// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__DckZa","canvas":"style_canvas__p6Zr0","button":"style_button__E0Mnd"};